import React from 'react';
import { aboutInfo } from '../data/mock';
import { CheckCircle } from 'lucide-react';

const AboutSection = () => {
  return (
    <section id="sobre" className="relative py-24 bg-black">
      {/* Background */}
      <div className="absolute inset-0">
        <div className="absolute left-0 top-1/2 -translate-y-1/2 w-96 h-96 bg-cyan-400/10 rounded-full blur-[120px]" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div>
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-cyan-400/10 border border-cyan-400/20 mb-6">
              <span className="text-cyan-400 text-sm font-medium">Quem Somos</span>
            </div>
            
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6">
              {aboutInfo.title.split(' ')[0]}{' '}
              <span className="text-cyan-400">{aboutInfo.title.split(' ').slice(1).join(' ')}</span>
            </h2>
            
            <p className="text-white/60 text-lg leading-relaxed mb-8">
              {aboutInfo.description}
            </p>

            {/* Highlights */}
            <div className="space-y-4">
              {[
                'Equipe especializada em tecnologia',
                'Suporte dedicado e personalizado',
                'Soluções escaláveis e modernas',
                'Compromisso com prazos e qualidade'
              ].map((item) => (
                <div key={item} className="flex items-center gap-3">
                  <CheckCircle className="w-5 h-5 text-cyan-400 flex-shrink-0" />
                  <span className="text-white/80">{item}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Right Content - Stats Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
            {aboutInfo.highlights.map((highlight, index) => (
              <div
                key={highlight.label}
                className="group p-8 bg-white/[0.02] border border-white/10 hover:border-cyan-400/50 transition-all duration-400 text-center"
              >
                <div className="text-5xl font-bold text-cyan-400 mb-2 group-hover:scale-110 transition-transform">
                  {highlight.value}
                </div>
                <div className="text-white/50 text-sm">
                  {highlight.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
